import { PageHero } from '@/components/ui/PageHero'
import { kandakePortrait } from '@/assets/siteMedia'

export const AboutHero = () => (
  <PageHero
    title="Kandake"
    accent="Makonnen"
    image={kandakePortrait}
    imageAlt="Kandake Makonnen, founder of Instrumental Health"
    highlights={[
      'BSc (Hons) Medical Herbalism',
      'Practice across the UK & Jamaica',
      'Studied with traditional healers',
    ]}
    description={
      <p>
        BSc (Hons) Medical Herbalist · Educator · Author · Speaker. Over two decades bridging
        traditional African and Caribbean healing wisdom with modern clinical science.
      </p>
    }
  />
)
